import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  Agreement,
  AgreementListItem,
  AgreementLogListItem,
  AgreementVersion,
  AgreementVersionListItem,
  CreateAgreementRequest,
  CreateVersionRequest,
  UpdateAgreementRequest,
  UpdateVersionRequest,
} from '@models/index';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class AgreementsService {
  private readonly url = `${environment.bffUrl}/agreements`;
  constructor(private http: HttpClient) {}

  getAll(): Observable<AgreementListItem[]> {
    return this.http.get<AgreementListItem[]>(this.url);
  }

  getOne(id: string): Observable<Agreement> {
    return this.http.get<Agreement>(`${this.url}/${id}`);
  }

  add(agreement: CreateAgreementRequest): Observable<Agreement> {
    return this.http.post<Agreement>(this.url, agreement);
  }

  update(id: string, agreement: UpdateAgreementRequest): Observable<Agreement> {
    return this.http.put<Agreement>(`${this.url}/${id}`, agreement);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.url}/${id}`);
  }

  getAgreementVersion(agreementId: string, versionId: string): Observable<AgreementVersion> {
    return this.http.get<AgreementVersion>(`${this.url}/${agreementId}/versions/${versionId}`);
  }

  addAgreementVersion(agreementId: string, version: CreateVersionRequest): Observable<AgreementVersion> {
    return this.http.post<AgreementVersion>(`${this.url}/${agreementId}/versions`, version);
  }

  deleteAgreementVersion(agreementId: string, versionId: string): Observable<void> {
    return this.http.delete<void>(`${this.url}/${agreementId}/versions/${versionId}`);
  }

  publishAgreementVersion(agreementId: string, versionId: string): Observable<AgreementVersion> {
    return this.http.post<AgreementVersion>(`${this.url}/${agreementId}/versions/${versionId}/publish`, undefined);
  }

  updateAgreementVersion(agreementId: string, versionId: string, version: UpdateVersionRequest): Observable<AgreementVersion> {
    return this.http.put<AgreementVersion>(`${this.url}/${agreementId}/versions/${versionId}`, version);
  }

  getLogs(id: string): Observable<AgreementLogListItem[]> {
    return this.http.get<AgreementLogListItem[]>(`${environment.bffUrl}/agreement-log/${id}`);
  }

  getVersions(id: string): Observable<AgreementVersionListItem[]> {
    return this.http.get<AgreementVersionListItem[]>(`${this.url}/${id}/versions`);
  }
}
